module.exports = __webpack_public_path__ + "static/media/logo_icon.64591b5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_icon.png
// module id = 559
// module chunks = 0